import { Dispatch, SetStateAction, useState } from "react";

import { RegulatorySearchFilterType } from "@/components/business/RegulatoryContainer/regulatoryList.types";
import SearchInput from "@atoms/SearchInput/SearchInput";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import RegulatorySearchFilterSelect from "./components/RegulatorySearchFilterSelect/RegulatorySearchFilterSelect";
import {
  REGULATORY_LIST_INFO_FILTER,
  REGULATORY_LIST_PRESS_INFO_FILTER_KEY,
} from "./constants/pressInfoFilter.constants";
import * as S from "./RegulatoryPressInfoSearch.style";

interface Props {
  currentPressFilter: RegulatorySearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<RegulatorySearchFilterType>>;
}

const RegulatoryPressInfoSearch = ({
  currentPressFilter,
  setCurrentFilter,
}: Props) => {
  const [regulatoryListFilter, setRegulatoryListFilter] =
    useRegulatoryListFilterState();
  const [typing, setTyping] = useState("");

  const { search } = regulatoryListFilter;

  const handleSearchKeyboard = () => {
    const currentInput = typing.trim();

    const newSearch = { ...search };
    REGULATORY_LIST_PRESS_INFO_FILTER_KEY.forEach(
      (key) => delete newSearch[key],
    );
    newSearch[currentPressFilter.key] = currentInput;

    if (currentInput) {
      setRegulatoryListFilter({
        ...regulatoryListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  const handleSearchButton = () => {
    const currentInput = typing.trim();

    if (currentInput) {
      const newSearch = { ...search };
      REGULATORY_LIST_PRESS_INFO_FILTER_KEY.forEach(
        (key) => delete newSearch[key],
      );
      newSearch[currentPressFilter.key] = currentInput;

      setRegulatoryListFilter({
        ...regulatoryListFilter,
        search: newSearch,
        page: 1,
      });
    }
  };

  return (
    <S.PressInfoSearchWrapper>
      <RegulatorySearchFilterSelect
        subTitle="Info Filter"
        filterList={REGULATORY_LIST_INFO_FILTER}
        currentFilter={currentPressFilter}
        setCurrentFilter={setCurrentFilter}
      />
      <S.PressInfoSearchTitle>
        <SearchInput
          placeholder="Enter text for clinical trial registry search"
          onSearchButton={handleSearchButton}
          handleSearchKeyboard={handleSearchKeyboard}
          typing={typing}
          setTyping={setTyping}
          widthResize
        />
      </S.PressInfoSearchTitle>
    </S.PressInfoSearchWrapper>
  );
};

export default RegulatoryPressInfoSearch;
